
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vendor/[vendorUrlKey]",
      function () {
        return require("private-next-pages/vendor/[vendorUrlKey].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vendor/[vendorUrlKey]"])
      });
    }
  